<template>
  <div class="tab-face content-box">
    <div class="setup_title" style="margin-top: 0"><i></i>面捕采集</div>
    <div class="setup_content">
      <div class="setup_box" style="display: none">
        <div class="setup_lable">显示摄像头：</div>
        <div class="setup_block">
          <toggle-switch
            :checked="showVideo"
            @change="VideoChange"
          ></toggle-switch>
        </div>
      </div>
      <div class="setup_box">
        <div class="setup_lable">当前摄像头：</div>
        <div class="setup_block">
          <select v-model="camera" @change="openVideo">
            <option value="">默认摄像头</option>
            <option
              v-for="(camera, cindex) in faceCameraList"
              :key="cindex"
              :value="camera.id"
            >
              {{ camera.label }}
            </option>
          </select>
        </div>
      </div>
      <div class="setup_box">
        <div class="setup_lable">采集频率：</div>
        <div class="setup_block">
          <select v-model="aioption.rate" @change="updateAioption">
            <option value="60">60次/秒</option>
            <option value="40">40次/秒</option>
            <option value="30">30次/秒</option>
            <option value="25">25次/秒</option>
            <option value="20">20次/秒</option>
            <option value="15">15次/秒</option>
            <option value="10">10次/秒</option>
            <option value="5">5次/秒</option>
            <option value="1">1次/秒</option>
          </select>
        </div>
      </div>
    </div>

    <div class="setup_title"><i></i>动捕设置</div>
    <div class="setup_content">
      <div class="setup_box">
        <div class="setup_lable">动捕模式</div>
        <div class="setup_block" style="width: 260px; padding: 5px 0">
          <select name="" v-model="body_pose" @change="switchBodyPose">
            <option value="0">面部捕捉(Intel i5及以上)</option>
            <option value="1">上身捕捉(Intel i7及以上)</option>
          </select>
        </div>
      </div>
      <div class="setup_box">
        <div class="setup_lable">眼部灵敏度：</div>
        <div class="setup_block">
          <select
            name=""
            v-model="aioption.eye_sensitivity"
            @change="updateAioption"
          >
            <option value="6">6(最灵敏)</option>
            <option value="5">5(灵敏)</option>
            <option value="4">4(正常)</option>
            <option value="3">3(一般)</option>
          </select>
        </div>
      </div>
    </div>
    <div
      class="setup_content"
      v-if="user && false"
      v-show="user.type == 1 || user.type == 2"
    >
      <div class="setup_box" v-if="user.type == 2">
        <div class="setup_lable">物理强度：</div>
        <div class="setup_block" style="width: 260px; padding: 5px 0">
          <vue-slider
            v-model="option.t9physicsRig"
            :min="1"
            :max="10"
            @change="updateOption()"
            :process-style="{ backgroundColor: 'pink' }"
          ></vue-slider>
        </div>
      </div>
      <div class="setup_box" v-show="user.type == 1">
        <div class="setup_lable">模拟风力：</div>
        <div class="setup_block">
          <toggle-switch
            :checked="windType"
            @change="switchWindType"
          ></toggle-switch>
        </div>
      </div>

      <div class="setup_box" v-if="false">
        <div class="setup_lable">自动呼吸：</div>
        <div class="setup_block">
          <toggle-switch
            :checked="aioption.breath_auto"
            @change="switchBreath"
          ></toggle-switch>
        </div>
      </div>
      <div class="setup_box">
        <div class="setup_lable">瞳孔捕捉：</div>
        <div class="setup_block">
          <toggle-switch
            :checked="aioption.eye_iris"
            @change="switchEyeIris"
          ></toggle-switch>
        </div>
      </div>
      <div class="setup_box" v-if="false">
        <div class="setup_lable">双眼同步：</div>
        <div class="setup_block">
          <toggle-switch
            :checked="option.eye_sync"
            @change="switchSync"
          ></toggle-switch>
        </div>
      </div>
      <div class="setup_box" v-if="false">
        <div class="setup_lable">自动眨眼：</div>
        <div class="setup_block">
          <toggle-switch
            :checked="option.eye_outo"
            @change="switchEyeOuto"
          ></toggle-switch>
        </div>
      </div>
    </div>
    <div v-if="user && false" v-show="user.type == 1 || user.type == 2">
      <div class="setup_title" style="margin-top: 0"><i></i>空间移动增幅</div>
      <div class="setup_content">
        <div class="setup_box">
          <div class="setup_lable" style="text-align: center">x轴：</div>
          <div class="setup_block" style="width: 260px; padding: 5px 0">
            <vue-slider
              v-model="option.range.x"
              :min="0"
              :max="100"
              @change="updateRange('x', $event)"
              :process-style="{ backgroundColor: 'pink' }"
            ></vue-slider>
          </div>
        </div>
        <div class="setup_box">
          <div class="setup_lable" style="text-align: center">y轴：</div>
          <div class="setup_block" style="width: 260px; padding: 5px 0">
            <vue-slider
              v-model="option.range.y"
              :min="0"
              :max="100"
              @change="updateRange('y', $event)"
              :process-style="{ backgroundColor: 'pink' }"
            ></vue-slider>
          </div>
        </div>
        <div class="setup_box">
          <div class="setup_lable" style="text-align: center">z轴：</div>
          <div class="setup_block" style="width: 260px; padding: 5px 0">
            <vue-slider
              v-model="option.range.z"
              :min="0"
              :max="100"
              @change="updateRange('z', $event)"
              :process-style="{ backgroundColor: 'pink' }"
            ></vue-slider>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import ToggleSwitch from '@/components/v-switch/index.vue'
import { localData } from '@/components/util/util_fun.js'
import VueSlider from 'vue-slider-component'


export default {
  name: 'setface',
  // props: ['user', 'carmeraList',],
  props: {
    user: {
      type: Object,
      default: () => ({})
    },
    carmeraList: {
      type: Array,
      default: () => []
    },
  },
  name: 'Catch',
  components: {
    ToggleSwitch,
    VueSlider,

  },
  data () {
    return {
      //     range:{ //空间移动增幅
      //         x:15,
      //         y:5,
      //         z:50
      //     },
      userconfig: {},
      showVideo: false,//是否显示摄像头人脸
      camera: "",//当前选择的摄像头
      faceCameraList: [],//摄像头列表
      body_pose: 0,
      aioption: { //可配置参数
        rate: 30,//AI分析频率，每秒识别次数，建议（15-30）
        inputSize: 160, //识别使用的图片尺寸，越大性能越低，人站的越远，这个数要求越大
        scoreThreshold: 0.5,//数据置信度要求，因使用微型模型，别超过0.7
        eye_sensitivity: 6,//一般在0.1-0.4之间
        eye_iris: true, //是否开启瞳孔追踪（增大性能消耗）
        body_pose: false,
        breath_auto: true,
        position: false,//生体定位，放大缩小
      },
      option: { //可选参数
        range: { x: 0, y: 0, z: 0 },
        t9physicsRig: 1,//物理强度0-10
        eye_sync: true, //强制同步眨眼
        eye_outo: false, //自动眨眼（眨眼效果捕捉不好时，将本功能打开）
      },
      windType: false,//db模型风力设置
      // isWindows: false,//是不是客户端中使用
      templ: "dark",//主题模式dark，light
    }
  },
  created () {
    this.userconfig = localData("get", "userconfig")
    // var userAgent = navigator.userAgent.toLowerCase()
    // if (userAgent.indexOf(' electron/') > -1) {
    //   this.isWindows = true
    // }
    //开始初始化模型
    this.init()
  },


  methods: {

    VideoChange (data) {
      if (typeof (data) == "boolean") {
        this.showVideo = data
        // if(data){
        //     document.getElementById("inputVideo").style.display="block";
        // }else{
        //     document.getElementById("inputVideo").style.display="none";
        // }
      }
    },

    //初始
    async init () {
      // console.log("初始化模型")
      if (this.carmeraList && this.carmeraList.length > 0) {
        // console.log(JSON.stringify(this.carmeraList))
        this.faceCameraList = this.carmeraList
      } else {
        this.getfaceCameraList()
      }
      // console.log('this.userconfig', this.userconfig)
      if (this.userconfig) {
        if (this.userconfig.camera != "") {
          this.camera = this.userconfig.camera
        }
        this.aioption.rate = this.userconfig.rate

        this.body_pose = this.userconfig.motioncap
        this.switchBodyPose()//更新V2C

        this.templ = this.userconfig.temp ? this.userconfig.temp : 'dark'
      }

    },

    //窗口程序获取摄像头回调
    videoListChange (list) {
      this.faceCameraList = list
    },


    //获取摄像头列表
    getfaceCameraList () {

      var that = this
      navigator.mediaDevices.enumerateDevices().then(function (devices) {

        that.faceCameraList = []
        devices.forEach(function (device) {
          if (device.kind == 'videoinput' && device.deviceId.length > 0) {
            that.faceCameraList.push({
              'label': device.label,
              'id': device.deviceId
            })
          }
        })
      })
        .catch(function (err) {
          console.log("获取摄像头错误" + err)
        })
      // console.log('获取到的摄像头列表', that.faceCameraList)
    },


    //切换摄像头
    openVideo () {
      console.log('切换摄像头', this.camera)
      this.$emit("videoSelect", this.camera)
    },




    //*******************************这里都是设置项方法*************************************** */


    //左右眨眼同步-option参数
    switchSync (data) {

      if (typeof (data) == "boolean") {
        this.option.eye_sync = data
        this.updateOption()
      }
    },
    //自动眨眼-option参数
    switchEyeOuto (data) {
      if (typeof (data) == "boolean") {
        this.option.eye_outo = data

        //不开启自动眨眼，其他俩项关闭
        if (this.option.eye_outo) {

          //瞳孔捕捉关闭
          this.aioption.eye_iris = false
          //强制同步眨眼关闭
          this.option.eye_sync = false

          this.updateAioption()
        }
        this.updateOption()
      }
    },
    // 自动呼吸
    switchBreath (data) {
      if (typeof (data) == "boolean") {
        this.aioption.breath_auto = data
        this.updateAioption()
        // this.openPose()
      }

    },
    //瞳孔捕捉-aioption参数
    switchEyeIris (data) {
      if (typeof (data) == "boolean") {
        this.aioption.eye_iris = data

        //不捕捉瞳孔时自动眨眼
        if (!this.aioption.eye_iris) {
          this.option.eye_outo = true
          // console.log(this.option.eye_outo);
          this.updateOption()
        }
        this.updateAioption()
      }
    },

    //动作捕捉-aioption参数
    switchBodyPose () {
      var data = this.body_pose
      if (data == 0) {
        this.aioption.body_pose = false
      }
      else if (data == 1) {
        this.aioption.body_pose = true
      }

      this.$emit("setconfig", "motioncap", data)//更新保存
      this.updateAioption()//更新到V2C
    },
    //是否进行空间移动-aioption参数
    switchPosition (data) {
      if (typeof (data) == "boolean") {
        this.aioption.position = data
        console.log(this.aioption.position)
        this.updateAioption()
      }
    },

    // // db风力开关
    switchWindType (type) {

      // this.modelClass.windInit(type)
    },

    // //修改option参数
    // updateOption(){

    //     this.modelClass.option(this.option);

    // },
    updateRange (type, data) {
      this.option.range[type] = data
      this.updateOption()

    },
    //修改aioption参数，select绑定的值都会变成string，这里公共处理一下
    updateAioption () {
      this.aioption.rate = parseInt(this.aioption.rate)
      this.aioption.eye_sensitivity = parseInt(this.aioption.eye_sensitivity)
      face2ctoo.option(this.aioption)
      //   console.log(face2ctoo)
      // this.setaioption(this.w,this.aioption)
      let userconfig = {
        bg: this.userconfig.bg,
        shuping: this.userconfig.shuping,
        isShowGuide: this.userconfig.isShowGuide,
        camera: this.camera,
        motioncap: this.body_pose,
        temp: this.templ,
        rate: this.aioption.rate,
      }
      // console.log('this.userconfig', userconfig)
      localData("set", "userconfig", userconfig)


    },
    /**
     * 用户更新保存用户习惯
     */
    setconfig (name, newValue) {
      // console.log(name,newValue);
      this.userconfig[name] = newValue
      localData("set", "userconfig", this.userconfig)
      t9render.sendmsg({ type: "userconfig", data: this.userconfig })

    },
    videoSelect (deviceId) {

      this.setconfig("camera", deviceId)//保存到用户习惯
      // this.ws.sendMsg(104, "切换摄像头", deviceId)
      face2ctoo.face_stop()
      var videoObj = { "video": true }
      if (deviceId != "") {

        //切换摄像头
        videoObj = { "video": { deviceId: deviceId } }
      }

      const videoEl = document.getElementById("inputVideo")
      var that = this
      navigator.mediaDevices.getUserMedia(videoObj).then(function (stream) {

        videoEl.srcObject = stream
        videoEl.onloadeddata = async function () {
          videoEl.play()
          that.getFacePoint()
        }
      })

    },

  },
  watch: {


  },

}
</script>
